const vrSystems = () => {
    const querySelectors = {
        vrSystemsFirstChild: document.querySelectorAll('.vr-systems a:first-child'),
        vrSystemsEl: document.querySelectorAll('.vr-systems'),
    }

    const toggleVrSystems = (el, action = 'open') => {
        if (action === 'open') {
            el.closest('.vr-systems').classList.add('open'); // Unused in css
        } else {
            el.closest('.vr-systems').classList.remove('open'); // Unused in css
        }

        const vrSystemLinks = el.parentNode.querySelectorAll('.btn:not(.dropdown)');
        const vrSystemsOverlay = el.parentNode.querySelector('.vr-systems-overlay');
        const vrSystemLinksArr = action === 'open' ? Array.from(vrSystemLinks) : Array.from(vrSystemLinks).reverse();
        let prevElHeight = el.parentNode.querySelector('.dropdown').offsetHeight + 10;

        vrSystemLinksArr.forEach((vrSystemLink, index) => {
            if (action === 'open') {
                vrSystemLink.style.opacity = 1;
                vrSystemLink.style.top = `${prevElHeight}px`;
            } else {
                vrSystemLink.style.opacity = 0;
                vrSystemLink.style.top = 0;
            }

            prevElHeight += vrSystemLink.offsetHeight + 10;
        });

        if (action === 'open') {
            vrSystemsOverlay.style.height = `${prevElHeight}px`;
        } else {
            vrSystemsOverlay.style.height = '0px';
        }
    }

    const handleMouseenterVrSystems = (e) => {
        if (window.innerWidth < 768) return;

        setTimeout(() => {
            if (window.preventVRClose) return;

            toggleVrSystems(e.target, 'open');
        }, 150);
    }

    const handleMouseleaveVrSystems = (e) => {
        if (window.innerWidth < 768) return;

        if (window.preventVRClose) return;

        toggleVrSystems(e.target, 'close')
    }

    const handleClickVrSystems = (e) => {
        e.preventDefault();

        if (window.innerWidth >= 768) return;

        if (e.target.parentNode.classList.contains('open')) {
          toggleVrSystems(e.target, 'close')
        } else {
            toggleVrSystems(e.target, 'open');
        }
    }

    const setupListeners = () => {
        querySelectors.vrSystemsFirstChild.forEach((vrSystemFirstChild) => {
            vrSystemFirstChild.addEventListener('mouseenter', handleMouseenterVrSystems);

            vrSystemFirstChild.addEventListener('click', handleClickVrSystems)
        });

        querySelectors.vrSystemsEl.forEach((vrSystemEl) => {
            vrSystemEl.addEventListener('mouseleave', handleMouseleaveVrSystems);
        });
    }

    return {
        init: () => {
            setupListeners();
        },
    }

}

export default vrSystems().init;
